import React from "react"
import { GlobalView, useSetGlobalView } from "@/store/view"
import { collect } from "@/utils/sdk"
import Text from "@/components/Text"
import styles from "./index.module.scss"
import { useGameStore } from "@/store/game"
import { showConfirm } from "@/components/Confirm"
import { i18n } from "@/i18n"
import { useRoleInfo } from "@/user/session"
import { triggerLogin } from "@/utils/loginTrigger"

export type RecallButtonStage = "loading" | "mainGame"

interface RecallButtonProps {
    stage: RecallButtonStage
    className?: string
}

export const RecallButton: React.FC<RecallButtonProps> = ({
    stage,
    className,
}) => {
    const setGlobalView = useSetGlobalView()
    const reset = useGameStore((state) => state.reset)
    const user = useRoleInfo()
    const addParam = () => {
        const url = new URL(window.location.href)
        url.searchParams.append("page", "recall")
        window.history.replaceState({}, document.title, url.toString())
    }
    const toRecall = () => {
        if (!user) {
            triggerLogin()
            return
        }
        if (stage === "mainGame") {
            showConfirm({
                content: i18n.get("game.recallTip"),
                onOk: () => {
                    reset()
                    setGlobalView(GlobalView.RECALL)
                    addParam()
                    collect("jumpto_recall", {})
                },
                onCancel: () => {},
            })
        } else {
            setGlobalView(GlobalView.RECALL)
            addParam()
            collect("jumpto_recall", {})
        }
    }

    return (
        <div
            className={`${styles.recallBtn} ${styles[`recallBtn${stage === "loading" ? "Other" : "MainGame"}`]} ${className || ""}`}
            onClick={toRecall}
        >
            <Text
                className={styles.recallBtnText}
                type="main"
                path="main.btn_recall"
            />
            {/* <OutlinedText
                className={styles.recallBtnText}
                text={i18n.get("main.btn_recall")}
                fontSize={26}
                // strokeWidth={4}
                fillColor={"#FDF8EF"}
                strokeColor={"#8E7355"}
                fontFamily="a한글세상B"
            /> */}
        </div>
    )
}
